import React from 'react';
import { graphql } from "gatsby"
import classnames from 'classnames';

import PancakeIntro from "../PancakeIntro";
import Pancake from "./Pancake";
import Tabs from "../Tabs"
import PancakesStack from '../PancakesStack';

import "./Tabs.scss";

const TabsPancake = props => {

  const { title, text, theme, tabs, className } = props;

  return (
    <Pancake className={classnames("PancakeTabs", className)} theme={theme}>
      {(title || text) && <PancakeIntro title={title} text={text} />}
      {tabs && tabs.length > 0 &&
        <Tabs>
          {tabs.map(tab => {
          return (
              <Tabs.Tab label={tab.title}>
              <PancakesStack pancakes={tab.pancakes} />
            </Tabs.Tab>
          )})}
        </Tabs>
      }
    </Pancake>
  );
}

export const query = graphql`
  fragment SanityTabs on SanityTabs {
    _key
    _type
    pancakeIntro {
      pancakeText
      pancakeTitle
    }
    tabs {
      pancakes {
        ...SanityPancakeText
        ...SanityPancakeCards
        ...SanityPancakeTextImage
        ...SanityPancakePreFooter
        ...SanityPancakeFeaturesHighlight
        ...SanityPancakeCustomerQuote
        ...SanityPancakeExplore
        ...SanityPancakeVideo
        ...SanityTrySourceControlProvider
        ...SanityPancakeLogos
        ...SanityPancakeJobs
        ...SanityTeamPancake
        ...SanitySpeakersPancake
        ...SanityPancakeSchedule
        ...SanityPancakeHubspotForm
        ...SanityBlogPostsListing
        ...SanityPancakeVideosList
        ...SanityPancakeTextSidebar
      }
      title
      _type
    }
    theme
  }
`

export default TabsPancake;